import React from 'react';
import { Link } from 'react-router-dom';
import { staffingServices } from '../data/mock';
import { Reveal } from './motion';
import SectionHead from './SectionHead';
import StaffCard from './StaffCard';

// Cards pin and stack as you scroll (pure CSS sticky).
const StaffingSection = () => (
  <section className="py-10">
    <div className="max-w-6xl mx-auto px-6">
      <SectionHead index="03" label="IT as a service" title="Expert talent, {{on demand.}}">
        Certified professionals without the overhead. Scale your team up or down as the work demands.
      </SectionHead>
      <div className="pb-8">
        {staffingServices.map((s, i) => (
          <StaffCard key={s.id} role={s} index={i} variant="wide" className="sticky mb-6" style={{ top: `${6.5 + i * 1.4}rem`, minHeight: '16rem' }} />
        ))}
      </div>
      <Reveal><Link to="/contact" className="btn btn-primary">Get a quote</Link></Reveal>
    </div>
  </section>
);

export default StaffingSection;
